<script>
  /**
   * SelectCell — the `Table` checkbox column used in selection mode.
   *
   * `selection` and `getKey` are destructured once rather than read reactively:
   * `Table` sets `renderComponent.props` at column-definition time and never
   * swaps the object. `getKey` defaults to `rulename`, matching `createSelection`.
   *
   * @example
   * const selectColumn = {
   *   key: 'select',
   *   title: '',
   *   value: () => '',
   *   renderComponent: { component: SelectCell, props: { selection } },
   *   headerClass: 'select-cell'
   * };
   */

  import { format } from 'svelte-i18n';

  /**
   * The table row this cell belongs to. Supplied by `Table`.
   * @type {Object}
   */
  export let row = {};

  /**
   * Cell props from the column definition. Must contain `selection`; `getKey`
   * is required when the selection is keyed by anything other than `rulename`.
   * @type {{ selection: Object, getKey?: (row: Object) => string }}
   */
  export let props = {};

  const { selection, getKey = (item) => item.rulename } = props;

  $: key = getKey(row);
  $: selected = $selection.has(key);
</script>

<input
  class="form-check-input"
  type="checkbox"
  checked={selected}
  on:click|stopPropagation
  on:change={() => selection.toggle(row)}
  aria-label="{$format('label.SELECT')} {key}"
/>
